import {ChangeDetectionStrategy, Component, OnChanges, SimpleChanges, inject, input, output, signal} from "@angular/core";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {AccountModel} from "../../../../account/angular/models/account.model";
import {ThreePLSupplyAccountsHttpService} from "../../services/threepl-supply-accounts-http.service";
import {
  SupplyAccountPanelData, SupplyAccountPanelResult, ThreeplSupplyAccountSelectPanelComponent,
} from "../threepl-supply-account-select-panel/threepl-supply-account-select-panel.component";

export interface SupplyAccountChange {
  account: AccountModel | undefined;
  id?: string;
}

@Component({
  selector: "app-threepl-supply-account-select",
  templateUrl: "./threepl-supply-account-select.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplSupplyAccountSelectComponent implements OnChanges {
  readonly selectedId = input<string>();
  readonly type = input.required<string>();
  readonly placeholder = input<string>();
  readonly isRequired = input(false);
  readonly isDisabled = input(false);
  readonly submitted = input(false);

  readonly accountChange = output<SupplyAccountChange>();

  readonly selectedText = signal("");

  private readonly panelService = inject(PanelService);
  private readonly http = inject(ThreePLSupplyAccountsHttpService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedId"]) {
      this.loadSelectedText();
    }
  }

  onOpen(event: MouseEvent): void {
    if (this.isDisabled()) {
      return;
    }
    const data: SupplyAccountPanelData = {selectedId: this.selectedId(), type: this.type(), placeholder: this.placeholder()};
    const panel = this.panelService.open(ThreeplSupplyAccountSelectPanelComponent, event, data, {
      position: {originX: "center", originY: "bottom", overlayX: "center", overlayY: "top"},
    });
    if (!panel) {
      return;
    }
    panel.afterClose$.subscribe((result: SupplyAccountPanelResult | null) => {
      if (!result) {
        return;
      }
      if (result.kind === "reset") {
        this.selectedText.set("");
        this.accountChange.emit({account: undefined});
        return;
      }
      this.selectedText.set(result.account.name ?? "");
      this.accountChange.emit({account: result.account, id: result.account.id});
    });
  }

  private loadSelectedText(): void {
    const id = this.selectedId();
    if (!id) {
      this.selectedText.set("");
      return;
    }
    this.http.getOne(id).subscribe({
      next: (account) => this.selectedText.set(account?.name ?? ""),
      error: () => this.selectedText.set(""),
    });
  }
}
